/**
 * Export CSV client-side para los reportes del BO.
 *
 * Convierte filas + columnas a un string CSV (RFC 4180: comillas dobles,
 * escape duplicando `"`, campos con coma/comilla/newline citados) y dispara
 * la descarga via Blob. No hay endpoint backend de export — exportamos lo que
 * ya se fetcheó para render (KISS).
 */
export interface CsvColumn<T> {
  header: string;
  /** Valor de la celda; null/undefined → cadena vacía. */
  value: (row: T) => string | number | null | undefined;
}

function escapeCell(raw: string | number | null | undefined): string {
  if (raw === null || raw === undefined) return '';
  const s = String(raw);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function toCsv<T>(rows: ReadonlyArray<T>, columns: ReadonlyArray<CsvColumn<T>>): string {
  const head = columns.map((c) => escapeCell(c.header)).join(',');
  const body = rows.map((row) => columns.map((c) => escapeCell(c.value(row))).join(',')).join('\r\n');
  return body ? `${head}\r\n${body}` : head;
}

export function downloadCsv<T>(
  filename: string,
  rows: ReadonlyArray<T>,
  columns: ReadonlyArray<CsvColumn<T>>,
): void {
  const csv = toCsv(rows, columns);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
